import type { Glyph } from "./types";

export const ChevronDownIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M44.48 13.159C44.811 12.789 45.38 12.758 45.75 13.09C46.12 13.422 46.151 13.99 45.82 14.36L25.67 36.841C25.499 37.031 25.256 37.14 25 37.14C24.744 37.14 24.5 37.031 24.329 36.841L4.18 14.36C3.848 13.99 3.879 13.422 4.249 13.09C4.619 12.758 5.188 12.789 5.52 13.159L24.999 34.891L44.48 13.159Z" />
  </svg>
);

export default ChevronDownIcon;
